import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Skip mounting on unsupported browsers (VISCAT-359). The pre-paint gate in
// public/index.html has already shown the "please update" card and hidden
// #root; mounting React here would run ES2020+ bundle code the browser can't
// parse. The gate and isSupportedBrowser() share one sentinel (structuredClone).
if (!document.documentElement.classList.contains('browser-unsupported')) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <App />
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
